export default __webpack_public_path__ + "static/task-activity-c1afceae77c3db961c0ad4f2af565b97.png";